import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { requestStatusCheckers } from '../../redux/helpers';
import useResponsive from '../../hooks/useResponsive';
import {
  MeSelectors,
  BooksSelectors,
  ChaptersSelectors,
  PackagesSelectors,
  PhotosSelectors,
  ProjectsSelectors,
  QuestionnairesSelectors,
  RatingsSelectors,
  UsersSelectors,
  VersionsSelectors,
  InterviewsSelectors,
  PricesSelectors,
} from '../../redux/selectors';

import Loader from './Loader';

import styles from '../../styles/views/components/PageLoader.module.scss';

const PageLoader = ({ forceLoading }) => {
  const { isMobile, isTablet, isDesktop } = useResponsive();

  const meRequestStatus = useSelector(MeSelectors.selectRequestStatus);
  const isMeRequestLoading = requestStatusCheckers.isLoading(meRequestStatus);

  const projectsRequestStatus = useSelector(ProjectsSelectors.selectRequestStatus);
  const isProjectsRequestLoading = requestStatusCheckers.isLoading(projectsRequestStatus);

  const packagesRequestStatus = useSelector(PackagesSelectors.selectRequestStatus);
  const isPackagesRequestLoading = requestStatusCheckers.isLoading(packagesRequestStatus);

  const chaptersRequestStatus = useSelector(ChaptersSelectors.selectRequestStatus);
  const isChaptersRequestLoading = requestStatusCheckers.isLoading(chaptersRequestStatus);

  const usersRequestStatus = useSelector(UsersSelectors.selectRequestStatus);
  const isUsersRequestLoading = requestStatusCheckers.isLoading(usersRequestStatus);

  const ratingsRequestStatus = useSelector(RatingsSelectors.selectRequestStatus);
  const isRatingsRequestLoading = requestStatusCheckers.isLoading(ratingsRequestStatus);

  const versionsRequestStatus = useSelector(VersionsSelectors.selectRequestStatus);
  const isVersionsRequestLoading = requestStatusCheckers.isLoading(versionsRequestStatus);

  const questionnairesRequestStatus = useSelector(QuestionnairesSelectors.selectRequestStatus);
  const isQuestionnairesRequestLoading = requestStatusCheckers.isLoading(questionnairesRequestStatus);

  const booksRequestStatus = useSelector(BooksSelectors.selectRequestStatus);
  const isBooksRequestLoading = requestStatusCheckers.isLoading(booksRequestStatus);

  const photosRequestStatus = useSelector(PhotosSelectors.selectRequestStatus);
  const isPhotosRequestLoading = requestStatusCheckers.isLoading(photosRequestStatus);

  const interviewsRequestStatus = useSelector(InterviewsSelectors.selectRequestStatus);
  const isInterviewsRequestLoading = requestStatusCheckers.isLoading(interviewsRequestStatus);

  const pricesRequestStatus = useSelector(PricesSelectors.selectRequestStatus);
  const isPricesRequestLoading = requestStatusCheckers.isLoading(pricesRequestStatus);

  const isLoading = isMeRequestLoading
    || isProjectsRequestLoading
    || isPackagesRequestLoading
    || isUsersRequestLoading
    || isRatingsRequestLoading
    || isChaptersRequestLoading
    || isVersionsRequestLoading
    || isQuestionnairesRequestLoading
    || isBooksRequestLoading
    || isPhotosRequestLoading
    || isInterviewsRequestLoading
    || isPricesRequestLoading
    || forceLoading;

  return (
    isLoading ? (
      <div className={styles.wrapper}>
        {isMobile && <Loader width="100px" height="100px" />}
        {isTablet && <Loader width="120px" height="120px" /> }
        {isDesktop && <Loader width="180px" height="180px" /> }
        <div className={styles.text}>{t('components.defaultLoadingPageText', { ns: i18next.Namespace.COMMON })}</div>
      </div>
    ) : null
  );
};

PageLoader.propTypes = {
  forceLoading: PropTypes.bool,
};

PageLoader.defaultProps = {
  forceLoading: false,
};

export default PageLoader;
